/**
 * Global JS - Restored to prevent 404 errors.
 * This file was found missing and causing issues on the product page.
 */
console.log('Global JS loaded.');
